import { ACCOUNT_DETAIL_TABS } from "../pages/Accounts/accountDetailTabs.js";

export const DEFAULT_ROUTE_ID = "acc-ov";

/** Main section route id → list path (no trailing slash). */
export const ROUTE_PATHS = {
  "acc-ov": "/accounts",
  "user-ov": "/users",
  "icp-ov": "/icp",
  "dev-ov": "/devices",
  "devtype-ov": "/device-types",
  "sim-ov": "/sims",
  "simtype-ov": "/sim-types",
  "rpt-bld": "/report-builder",
};

const PATH_TO_ROUTE_ID = Object.fromEntries(
  Object.entries(ROUTE_PATHS).map(([id, path]) => [path, id]),
);

const ACCOUNT_TAB_IDS = new Set(ACCOUNT_DETAIL_TABS.map((t) => t.id));

export function isKnownRouteId(routeId) {
  return routeId in ROUTE_PATHS;
}

export function normalizePathname(pathname) {
  if (!pathname || pathname === "/") return "/";
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed || "/";
}

/**
 * @returns {{ routeId: string, accountId?: string, tab?: string }}
 */
export function parsePathname(pathname) {
  const path = normalizePathname(pathname);

  if (path === "/") {
    return { routeId: DEFAULT_ROUTE_ID };
  }

  const accountMatch = path.match(/^\/accounts\/([^/]+)(?:\/([^/]+))?$/);
  if (accountMatch) {
    const accountId = decodeURIComponent(accountMatch[1]);
    const tab = accountMatch[2] ? decodeURIComponent(accountMatch[2]) : "info";
    return {
      routeId: "acc-ov",
      accountId,
      tab: ACCOUNT_TAB_IDS.has(tab) ? tab : "info",
    };
  }

  const routeId = PATH_TO_ROUTE_ID[path];
  if (routeId) {
    return { routeId };
  }

  return { routeId: DEFAULT_ROUTE_ID };
}

/**
 * @param {{ routeId: string, accountId?: string | null, tab?: string }} location
 */
export function buildPathname({ routeId, accountId, tab = "info" }) {
  if (routeId === "acc-ov" && accountId) {
    if (tab && tab !== "info") {
      return `/accounts/${encodeURIComponent(accountId)}/${encodeURIComponent(tab)}`;
    }
    return `/accounts/${encodeURIComponent(accountId)}`;
  }

  return ROUTE_PATHS[routeId] ?? ROUTE_PATHS[DEFAULT_ROUTE_ID];
}
